module.exports = __webpack_public_path__ + "media/images/icons/outlined/caret-up-d74d1750b9627074076682b9331c1bb6.svg";